// Sma200Widget/Sma200Cache.js
// Normal Cache — CacheBase2, singleton export (Engine Pattern rk=f03ae8b6).
// Holds the latest SMA200 slots per asset, keyed on each item's rk ("{ems}_{sid}_{window}").
// No custom overrides needed for now — base getAll/addOrUpdate/get(rk) cover everything.
//
// KNOWN ISSUE (rk=896be0200668464897d0dc11b9ae1f47): no prune-on-push — once RMQ starts
// pushing a new slot per asset per day, this grows unbounded. Deferred on purpose.
import CacheBase2 from '../../../services/engines/CacheBase2';

const _name = 'Sma200Cache';

class Sma200Cache extends CacheBase2 {
    initialize() {
        this._name = _name;
    }
}

const sma200Cache = new Sma200Cache();
export default sma200Cache;
